var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[(!_vm.loading)?_c('Total',{staticStyle:{"min-height":"200px"}}):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('Analysis',{staticStyle:{"min-height":"500px"}}):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('Transaction'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-643033f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/user/index.vue
// module id = null
// module chunks = 